import {API} from "../services/api.service";
export class Order {
  public status : string;
  public id : number;
  public url : string;
  public paymentMethod : string;
  public paymentStatus: string;
  public paymentUrl: string;
  public expectedDelivery: string;
  public methods: any;
  constructor(payload){
    if (payload) {
      this.id = payload.id;
      this.status = payload.status;
      this.url = payload.url;
      this.paymentMethod = payload.payment.method;
      this.paymentStatus = payload.payment.status;
      this.paymentUrl = payload.payment.url;
      this.expectedDelivery = payload.expectedDelivery;
      this.methods = payload.methods;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/classes/order.ts